import { fetchAuthSession } from "aws-amplify/auth";
import config from "../../../../config";
import { getIdToken } from "../../../userAuth";

// import logger from "../../../../logger";
import logger from "../../../../logger";

const { CANDOO_API_DOMAIN } = config;

const ENDPOINT = "aiquery";

const getAuthToken = async () => {
  let authorizationToken = null;
  try {
    const idToken = await getIdToken();
    authorizationToken = idToken;
  } catch (error) {
    const { identityId } = await fetchAuthSession({ forceRefresh: true });
    authorizationToken = identityId;
  }
  return authorizationToken;
};

export async function createSingleFileVectorStore(body) {
  const authorizationToken = await getAuthToken();
  try {
    const response = await fetch(
      `${CANDOO_API_DOMAIN}/${ENDPOINT}/createSingleFile`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: authorizationToken,
        },
        body: JSON.stringify(body),
      },
    );
    const parsedResponse = await response.json();
    if (response.status === 200) {
      return parsedResponse;
    } else if (parsedResponse.message === "Vector store already exists") {
      return {
        statusCode: 200,
      };
    }

    throw response;
  } catch (err) {
    logger.error(err);
    throw err;
  }
}

export async function deleteVectorStore(body) {
  const authorizationToken = await getAuthToken();
  try {
    const response = await fetch(
      `${CANDOO_API_DOMAIN}/${ENDPOINT}/deleteFromEFS`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: authorizationToken,
        },
        body: JSON.stringify(body),
      },
    );
    if (response.status === 200) {
      const parsedResponse = await response.json();
      return parsedResponse;
    }

    throw response;
  } catch (err) {
    logger.error(err);
    throw err;
  }
}

export async function getAiQuery(body) {
  const authorizationToken = await getAuthToken();
  try {
    const response = await fetch(`${CANDOO_API_DOMAIN}/${ENDPOINT}/`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: authorizationToken,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 200) {
      const parsedResponse = await response.json();
      return parsedResponse;
    }

    throw response;
  } catch (err) {
    logger.error(err);
    throw err;
  }
}
